import React from 'react';
import ModalWrapper, { withOnClose } from './ModalWrapper';
import Translator from '../../requests/apa/Translator';
import PipManager from '../../utils/pipManager/PipManager';
import Asset from '../../requests/apa/Asset';

import store from "../../store";
import {playFullMedia} from "../../actions/playmedia";

import './styles/AAFModalPlayOptions.scss';

const AAFModalPlayOptions = (props) => {
  let buttons = [];

  //Se migró esta funcion al ModalWrapper
  //PipManager.closePIP(Device,false);

  if (props.buttons) {
    const tmp = props.buttons.map(button => {
      const newButton = Object.assign({}, button);
      const cb = newButton.props.onClick;
      newButton.props.onClick = (e) => {
        props.handleClose(e, cb);
        PipManager.resizePIP();
      };
      return newButton;
    });
    buttons = [...buttons, ...tmp];
  }

  const p = {
    buttons,
    className: "modal-play-options",
    callbackWhenBack: () => {
        const nullPlayer = {
          ispip: false,
          islive: true,
          playerstate: 'STOPPING',
          event: null,
        };
        store.dispatch(playFullMedia(nullPlayer));
      props.callbackWhenBack && props.callbackWhenBack()
    },
    aafNewStyle: true,
    buttonsAlign: 'vertical',
    showLogo: false,
    title: Translator.get('playing_modal_keepWatching_title_label', 'Continúa con tu reproducción'),
    colorButtons: [
      {
        content: Translator.get('top_head_option_button_return', 'REGRESAR'),
        props: {
            color: 'yellow',
            className: 'modal-button-return',
            imgSrc: Asset.get('top_head_option_back', ''),
            onClick: () => {
              const nullPlayer = {
                ispip: false,
                islive: true,
                playerstate: 'STOPPING',
                event: null,
              };
              store.dispatch(playFullMedia(nullPlayer));
              props.handleClose()
            },
        },
      },
    ],
    yellowAction: () => {
      const nullPlayer = {
        ispip: false,
        islive: true,
        playerstate: 'STOPPING',
        event: null,
      };
      store.dispatch(playFullMedia(nullPlayer));
      props.handleClose()
    },
    onOpen: () => window.SpatialNavigation.focus('.btn-modal-bookmark')
  };

  return <ModalWrapper {...p} />;
}

export default withOnClose(AAFModalPlayOptions);



// WEBPACK FOOTER //
// ./src/components/Modal/AAFModalPlayOptions.jsx